
import AppRoutes from "./components/routes";
import "../src/components/styles/global.scss";


function App() {
  return (
    <div>
      <AppRoutes />
      
    </div>
  )
}

export default App;